import Vue from "vue";
import VueRouter from "vue-router";
import Calendar from "../views/Calendar.vue";
import Refresh from "../views/Refresh.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:eventid/:language?/refresh",
    name: "Refresh",
    component: Refresh,
  },
  {
    path: "/:eventid/:language?",
    name: "Calendar",
    component: Calendar,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
